// extracted by mini-css-extract-plugin
export default {"wrapper":"IconSideBar_wrapper__gkeGs"};